import type { UseMutationOptions } from 'react-query';
import { useMutation } from 'react-query';
import { getPrivateApi } from '../../../../services/api';
import { userMessage } from '../../../../utils/vy-toasts';
import { isError } from '@vy/utils';
import { QuickBooksExportInvoicesRequestPayload } from '@vy/api-definition';

export function useQuickBooksExportInvoices(
  options?: UseMutationOptions<void, unknown, QuickBooksExportInvoicesRequestPayload>,
) {
  return useMutation({
    mutationKey: ['quickbooksExportInvoices'],
    mutationFn: async ({ invoiceIds }) => {
      const api = getPrivateApi();

      return api.quickbooksExportInvoices({
        quickBooksExportInvoicesRequest: {
          invoiceIds,
        },
      });
    },
    onError: (error) => {
      if (isError(error)) {
        userMessage('error', error.message);
      }
    },
    ...options,
  });
}
